import { chatDocs } from "@/mocks/evidence";

export default function ChatSection() {
  return (
    <section id="chat" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="eyebrow text-xs font-semibold text-primary-700">04 / 聊天记录</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              聊天记录簿 · 对话逐条还原
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              国产黑料聊天记录按人、按时间整理成卷，关键句前后文一起保留，不再断章取义。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {chatDocs.map((c) => (
            <article
              key={c.id}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex items-center justify-between border-b border-dashed border-background-300 px-5 py-3.5">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-chat-3-line text-base" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">{c.lead}</p>
                    <p className="text-[11px] text-foreground-500">{c.id}</p>
                  </div>
                </div>
                <span className="text-xs text-foreground-500">{c.date}</span>
              </div>

              <div className="flex flex-1 flex-col gap-2.5 px-5 py-4">
                {c.lines.map((line, i) => (
                  <div
                    key={i}
                    className={
                      i % 2 === 0
                        ? "self-start max-w-[85%] rounded-lg rounded-tl-none bg-background-200 px-3.5 py-2 text-[13px] leading-5 text-foreground-800"
                        : "self-end max-w-[85%] rounded-lg rounded-tr-none bg-primary-600 px-3.5 py-2 text-[13px] leading-5 text-background-50"
                    }
                  >
                    {line.text}
                  </div>
                ))}
              </div>

              <div className="mt-auto border-t border-background-200 px-5 py-3.5">
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {c.title}
                </h3>
                <p className="mt-1.5 text-xs leading-5 text-foreground-500">
                  <i className="ri-information-line mr-1 text-primary-600" />
                  {c.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}